<div [ngClass]="{'static': !isActive, 'active': isActive}" class="container">
    <div class="content">
        <span (click)="openList()" *ngIf="!isActive">{{placeholderText}}</span>
        <div class="row a_center" *ngIf="isActive">
            <span (click)="openList()">{{values}}</span>
            <svg-icon (click)="clearList()" src="../../../assets/svg/close.svg"></svg-icon>
        </div>
    </div>
</div>